const CLOUD_FLARE_USER_INFO_ENDPOINT = '/client-info';

const cloudFlare = {
  getUserData: async (): Promise<Record<string, string>> => {
    const getUserInfoResponse = await fetch(CLOUD_FLARE_USER_INFO_ENDPOINT);

    if (!getUserInfoResponse.ok) {
      // eslint-disable-next-line no-console
      console.error('Failed to fetch user data from Cloudflare');
      return {};
    }

    const userData = (await getUserInfoResponse.json()) as Record<
      string,
      string
    >;

    if (!userData || typeof userData !== 'object') {
      // eslint-disable-next-line no-console
      console.error('Invalid user data format received from Cloudflare');
      return {};
    }

    return userData;
  },
};

export default cloudFlare;
